import { Checkbox } from "components/Atoms/inputs/Checkbox";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

interface Props {
  segment: server.dto.FlightSegment
  checked: boolean
  onSegmentClicked: (segment: server.dto.FlightSegment) => void
}

const FlightSearchResult = (props: Props) => <tr onClick={() => { props.onSegmentClicked(props.segment); }} className="hoverable">
  <td style={{ width: 20 }}>
    <Checkbox onChange={() => { }} checked={props.checked} />
  </td>
  <td>
    <div>{props.segment.flightNumber}</div>
  </td>
  <DepartureArrival departureArrival={props.segment.departure} />

  <td style={{ textAlign: "center", width: 80 }}>
    <div className="icon-arrow-right"></div>
  </td>
  <DepartureArrival departureArrival={props.segment.arrival} />
</tr>;

export default FlightSearchResult;

const DepartureArrival = ({ departureArrival }: { departureArrival: server.dto.FlightSegmentDepartureArrival }) => (<React.Fragment>
  <td className="nowrap" style={{ width: 70 }}>{formatTime(departureArrival.dateTimeLocal)}</td>
  <td style={{ width: 300 }}>
    {formatWrittenDayMonthYear(departureArrival.dateTimeLocal)}
    <div>{departureArrival.airport.location}</div>
    <div>{departureArrival.airport.name} [{departureArrival.airport.iata}]</div>
    <div>{RESX.Flight.Terminal} {departureArrival.terminal}</div>
  </td>
</React.Fragment>);
